class BrandStatementPenny extends HTMLElement {
  connectedCallback() {
    this.target = this.querySelector('.brand-statement-penny__inner');
    if (!this.target) return;

    this.observer = new IntersectionObserver(
      function(entries, observer) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -50px 0px' }
    );
    this.observer.observe(this.target);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }
}

customElements.define('brand-statement-penny', BrandStatementPenny);
